import React from 'react';

import { Box, LinearProgress, Typography } from '@mui/material';
import LoadingSpinner from 'components/LoadingSpinner';
import PropTypes from 'prop-types';

import styles from './syncProgress.module.css';

const SyncProgress = (props) => {
    const { showSyncProgress, syncProgress } = props;

    const canShowProgressAmount =
        showSyncProgress && Number.isFinite(syncProgress) && syncProgress >= 0;

    if (!showSyncProgress) {
        return null;
    }

    return (
        <Box className={styles.progress_container}>
            <Box className={styles.progress_header}>
                <Typography className={styles.progress_header_title}>
                    Listings are currently being synced...
                </Typography>
                {canShowProgressAmount ? (
                    <Typography className={styles.progress_header_amount}>
                        {Math.round(syncProgress)}%
                    </Typography>
                ) : (
                    <LoadingSpinner text={null} spinnerClassName={styles.spinner} />
                )}
            </Box>
            {canShowProgressAmount && (
                <LinearProgress
                    value={syncProgress}
                    variant="determinate"
                    color="primary"
                    classes={{
                        root: styles.progress_root,
                        bar: styles.progress_bar,
                    }}
                />
            )}
        </Box>
    );
};

SyncProgress.propTypes = {
    showSyncProgress: PropTypes.bool,
    syncProgress: PropTypes.number,
};

export default SyncProgress;
